/**
 *
 * 第三方公共类
 *
 */

function Common() {
  // 第三方合作列表请求uc
  this.bolUc = true;

  this.instituteLogin = {
    // 登录方式，0：手机号，1：邮箱
    loginWay: [0, 1]
  };

  // 是否显示退出按钮
  this.hideLogoutBtn = true;
}

export default Common;
